import type { BizzDashboardGraphMostBookedQuery } from '@funkey/types/graphql/graphql';

/**
 * Top-8 activities by booked-item count. Each (deal, activity) pair counted
 * once: a deal with two booked items of the same activity contributes 1.
 *
 * The caller filters items server-side via `items(status: WON)`, so every
 * item received here is an actual booking (FUN-4401).
 */
export function aggregateMostBookedActivities(
    deals: NonNullable<BizzDashboardGraphMostBookedQuery['business']>['deals'],
): ReadonlyArray<{ readonly id: number; readonly name: string; readonly count: number }> {
    const seen = new Set<string>();
    const counts = new Map<number, { id: number; name: string; count: number }>();

    for (const deal of deals) {
        for (const item of deal.items) {
            if (!item.activityVariant) continue;

            const activity = item.activityVariant.activity;
            const key = `${deal.id}:${activity.id}`;
            if (seen.has(key)) continue;
            seen.add(key);

            const existing = counts.get(activity.id);
            if (existing) existing.count += 1;
            else counts.set(activity.id, { id: activity.id, name: activity.name, count: 1 });
        }
    }

    return [...counts.values()].sort((a, b) => b.count - a.count).slice(0, 8);
}
